export default from './modal';



// WEBPACK FOOTER //
// ./app/components/modal/index.js